export enum ActiveDataCommands
{
    ADD_STACK = 'addStack',
    DELETE_STACKS = 'deleteStacks',
    ADD_CARDS = 'addCards',
    DELETE_CARDS = 'deleteCards',
    DELETE_STACK_CARDS = 'deleteStackCards',
    ADD_STACK_CARDS = 'addStackCards',
    MOVE_STACK = 'moveStack',
    FLIP_STACK = 'flipStack',
    FLIP_CARD = 'flipCard',
    CLEAR_FIELD = 'clearField',
    CHANGE_PLAYER_CARDS_COUNT = 'changePlayerCardsCount',
    LOCK_STACK = 'lockStack',
    UNLOCK_STACK = 'unlockStack',
    SHUFFLE_STACK = 'shuffleStack',
    ROTATE_STACK = 'rotateStack',
    DISABLE_STACKS = 'disableStacks',
    ENABLE_STACKS = 'enableStacks',
    CHANGE_META_TYPE = 'changeMetaType',
    CHANGE_STACK_VISIBILITY = 'changeStackVisibility',
}
